import styled from 'styled-components'
import { GREEN, WHITE } from '../../utils/colors'
import { MD } from '../../utils/screenSizes'

export const Container = styled.div`
  background-color: ${GREEN};
`

export const Inside = styled.div`
  width: 100%;
  max-width: 1236px;
  margin: 0 auto;
  padding: 30px 48px;

  display: flex;
  align-items: center;

  font-size: 16px;
  font-weight: 500;
  color: #fff;

  @media (max-width: ${MD}) {
    .logged_user {
      display: none;
    }
  }

  .menu {
    display: none;
    border: none;
    position: absolute;

    svg {
      fill: ${WHITE};
    }

    @media (max-width: ${MD}) {
      display: block;
      background-color: transparent;
    }
  }

  .near {
    flex: 1;
    margin-left: 60px;

    span {
      display: inline-block;
      margin-right: 29px;
      font-size: 20px;
    }

    @media (max-width: ${MD}) {
      display: none;
    }
  }

  .logo {
    img {
      width: 113px;
    }

    @media (max-width: ${MD}) {
      margin: 0 auto;
      display: block;

      img {
        width: 75px;
      }
    }
  }
`
